import React, {useState} from "react";
import styles from "./time-input.module.css";
import {addMessage, setWaitingResponse} from "../../store/stateSlice";
import {useDispatch} from "react-redux";
import {updateProfile} from "../../../../api";

const TimeInput = ({ title }) => {
  const [answered, setAnswered] = useState(false);
  const [input, setInput] = useState("");

  const dispatch = useDispatch();

  const handleOnSend = () => {
    if (input) {
      console.log(input);
      dispatch(addMessage(input));
      dispatch(setWaitingResponse());
      setAnswered(true);

      const [hour, minute] = input.split(":");

      updateProfile({
        land: "tarot-chat",
        step: "step5",
        topicType: "birthTime",
        topic: title,
        answer: {
          hour: Number(hour),
          minute: Number(minute)
        }
      })
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleOnSend();
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.input_text}>{title}</p>
      {!answered && (
        <div className={styles.input_container}>
          <input
            type="time"
            value={input}
            onInput={(e) => setInput(e.target.value)}
            placeholder="Enter your birth date here..."
            className={styles.input}
            onKeyDown={handleEnter}
          />
          <button className={styles.button} onClick={handleOnSend}></button>
        </div>
      )}
    </div>
  );
};

export { TimeInput };
